/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ProjectCleanupDetail from '@jira/spa-apps__admin-pages-performance-metric-detail-project-cleanup/src/ProjectCleanupDetail.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectCleanupDetail: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProjectCleanupDetail
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-project-cleanup" */ '@jira/spa-apps__admin-pages-performance-metric-detail-project-cleanup/src/ProjectCleanupDetail.tsx'
		),
	),
);

export const ProjectCleanupMetricDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectCleanupDetail}
		pageId="system-performance-metric-detail-project-cleanup"
		shouldShowSpinner
	/>
);
